export default class NewReport {
  constructor (file: File) {
    this.file = file
  }
  file: File
  site?: string
  period?: 'Monthly' | 'Quarterly' | 'Yearly'
  startDate?: string
}
